import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { ProductShelfContainer } from './ProductShelfContainer';

const ProductShelfRenderer = ({
  componentId,
  dataComponent,
  showTooFewProductsNotice,
  theme,
  homepageProductShelf
}) => {

  const { channel } = useContext(ExperienceContext);
  const {title, sortBy} = dataComponent || {};
  const itemIds = dataComponent?.productShelfData?.skus;
  const sortOrder = dataComponent?.sortOrderOptions;
  const navParam = dataComponent?.productShelfData?.navParam;
  const { defaultVariables } = useContext(QueryContext);
  const { isBrandPricingPolicyCompliant = false } = defaultVariables?.current;

  return (
    <>
      <QueryProvider
        cacheKey="product-shelf-cache"
        defaultVariables={{
          storeId: '121',
          zipCode: '30339',
          skipKPF: true,
          skipSubscribeAndSave: true,
          isBrandPricingPolicyCompliant,
          loyaltyMembershipInput: null
        }}
      >
        <ProductShelfContainer
          componentId={componentId}
          channel={channel}
          showTooFewProductsNotice={showTooFewProductsNotice}
          homepageProductShelf={homepageProductShelf}
          theme={theme}
          opts={{
            itemIds,
            navParam,
            sortBy,
            sortOrder,
            contentfulTitle: title
          }}
        />
      </QueryProvider>
    </>
  );
}

ProductShelfRenderer.propTypes = {
  componentId: string.isRequired,
  componentClass: string,
  showTooFewProductsNotice: bool,
  theme: string,
  homepageProductShelf: bool
};

ProductShelfRenderer.defaultProps = {
  componentClass: 'ProductShelfRenderer',
  showTooFewProductsNotice: false,
  theme: null,
  homepageProductShelf: false
};

export { ProductShelfRenderer };
